import { Flex, Text } from '@chakra-ui/react';

const NotFound = () => {
  return (
    <Flex
      justifyContent="space-around"
      alignItems="center"
      width="100%"
      height="100vh"
      backgroundColor="surfaceSecondaryFill"
    >
      <Text textStyle="headingSection">
        The page you are looking for does not exist!
      </Text>
    </Flex>
  );
};

export default NotFound;
